module.exports = __webpack_public_path__ + "img/Aviation_saf_1.e3eafa82.jpg";